import PurchaseProDeviceDialog from './PurchaseProDeviceDialog';

export default PurchaseProDeviceDialog;
